import { Component, input, output } from '@angular/core';
import { CommonModule } from '@angular/common';

export interface PlayerCardData {
  firstName: string;
  lastName: string;
  position: string;
  team: string;
  photo?: string | null;
  cost?: number | null;
}

@Component({
  selector: 'app-player-card',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './player-card.html',
  styleUrl: './player-card.css',
})
export class PlayerCard {
  player = input.required<PlayerCardData>();
  posColor = input<string | undefined>(undefined);
  nameAbbrev = input(false);
  showPhoto = input(true);
  clickable = input(false);

  cardClick = output<void>();

  normPos(pos: string): string {
    const p = (pos || '').toLowerCase();
    if (p === 'dst' || p === 'def') return 'pos-def';
    if (p === 'pk') return 'pos-k';
    return 'pos-' + p;
  }
}
